<nz-result
  [nzStatus]="'success'"
  [nzTitle]="documentTitle + ' successfully placed' | locale"
  [nzSubTitle]="('Thank you for placing ' + documentTitle + ', document number: ' | locale) + DocNum">
  <div nz-result-extra>
    <button nz-button nzType="default" [nzSize]="'large'" nzShape="round" (click)="goToShoppingList()">
      {{'Continue shopping' | locale}}
    </button>
  </div>
</nz-result>
